var exports = {
  "Q": "x31de4314--690be3--content",
  "U": "x31de4314--690be3--wide",
};

module.exports = exports;
